import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { AuthContext } from "../../App";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// SEO Форк 2: тумблер согласия на публичный профиль исполнителя (152-ФЗ, default OFF)
export const PublicProfileToggle = ({ user, showToast }) => {
  const { fetchUser } = useContext(AuthContext);
  const [enabled, setEnabled] = useState(!!user?.public_profile_consent);
  const [saving, setSaving] = useState(false);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    setEnabled(!!user?.public_profile_consent);
  }, [user?.public_profile_consent]);

  const toggle = async () => {
    if (saving) return;
    const next = !enabled;
    setSaving(true);
    try {
      await axios.put(`${BACKEND_URL}/api/profile/public-profile-consent`, { enabled: next });
      setEnabled(next);
      if (fetchUser) await fetchUser();
      showToast(
        next
          ? "Готово: ваш публичный профиль станет доступен поисковикам"
          : "Профиль скрыт из поиска",
        "success"
      );
    } catch (err) {
      showToast(err.response?.data?.detail || "Ошибка сохранения настройки", "error");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div
      data-testid="public-profile-consent-card"
      className="mb-6 p-4 rounded-xl border bg-white"
      style={{ borderColor: enabled ? "var(--reversia-teal, #0d9488)" : "#e5e7eb" }}
    >
      <div className="flex items-center justify-between gap-3">
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold text-gray-800">
            Показывать мой профиль в поиске Яндекс/Google
          </p>
          <p className="text-xs text-gray-500 mt-0.5">
            {enabled
              ? "Включено: публичная страница с вашим рейтингом и отзывами доступна поисковикам"
              : "Выключено: ваш профиль не виден в поисковых системах"}
            {" "}
            <button
              type="button"
              data-testid="public-profile-details-toggle"
              onClick={() => setExpanded(v => !v)}
              className="underline text-teal-600 hover:text-teal-700"
            >
              {expanded ? "скрыть подробности" : "подробнее"}
            </button>
          </p>
        </div>
        <button
          type="button"
          data-testid="public-profile-consent-toggle"
          onClick={toggle}
          disabled={saving}
          aria-checked={enabled}
          role="switch"
          className="relative flex-shrink-0 rounded-full transition-colors duration-200 disabled:opacity-50"
          style={{
            width: 44,
            height: 24,
            background: enabled ? "var(--reversia-teal, #0d9488)" : "#d1d5db",
          }}
          title={enabled ? "Отключить показ в поиске" : "Включить показ в поиске"}
        >
          <span
            className="absolute top-0.5 rounded-full bg-white shadow transition-all duration-200"
            style={{ width: 20, height: 20, left: enabled ? 22 : 2 }}
          />
        </button>
      </div>
      {expanded && (
        <div className="mt-3 pt-3 border-t border-gray-100 text-xs text-gray-500 space-y-1.5">
          <p>
            На публичной странице показываются только: имя и первая буква фамилии, рейтинг,
            количество выполненных заданий, статус-девиз и отзывы заказчиков.
          </p>
          <p>
            Email, телефон, фото и другие личные данные не публикуются. Согласие фиксируется
            в соответствии со 152-ФЗ, отключить показ можно в любой момент — страница
            перестанет открываться и будет исключена из поиска.
          </p>
        </div>
      )}
      {enabled && (
        <div className="mt-2">
          <a
            data-testid="public-profile-preview-link"
            href={`${BACKEND_URL}/api/seo/ispolnitel/${user.id}`}
            target="_blank"
            rel="noopener noreferrer"
            className="text-xs font-medium underline"
            style={{ color: "var(--reversia-teal, #0d9488)" }}
          >
            Посмотреть, как выглядит моя публичная страница
          </a>
        </div>
      )}
    </div>
  );
};
